import React, {Component} from "react";
import PropTypes from "prop-types";
import {TableHeaderColumn} from "react-bootstrap-table";
import {Date, Grid} from "../utils"

const formatRank = (cell, row) => {
	if (cell <= 0) {
		if (row.isDnf) {
			return 'DNF'
		} else if (row.isDns) {
			return 'DNS'
		} else if (row.isDisqualified) {
			return 'DSQ'
		}
		return ''
	}
	return cell
};

const formatFullName = (cell, row) => {
	return row.firstName ? (cell + ' ' + row.firstName) : cell
};

const formatTotalTime = (cell, row) => {
	if (!row.rank) {
		return null;
	}
	if (row.rank > 1) {
		return formatTime(row.behind, '+')
	}
	return formatTime(cell)
};

const formatTime = (time, prefix = "") => {
	if (time === 0) {
		return prefix + "0,0"
	}
	if (!time) {
		return null
	}
	if (time >= 600) {
		const m = ("00" + (Math.floor((time % 600) / 10)));
		return prefix + Math.floor(time / 600)
			+ ":" + m.substring(m.length - 2)
			+ "," + ((time % 600) % 10)

	} else {
		return prefix + Math.floor((time % 600) / 10)
			+ "," + ((time % 600) % 10)
	}
};

const formatPenalty = (time, withSuffix = true) => {
	const t = [];
	let h = 0, m = 0, s = 0;
	if (time >= 36000) {
		h = Math.floor(time / 36000);
		t.push(h + ':');
	}
	if (time >= 600) {
		m = Math.floor((time % 36000) / 600);
		t.push((h > 0 ? ('00' + m).substr(-2) : m) + ':');
	}
	if (time >= 10) {
		s = Math.floor((time % 600) / 10);
	}
	t.push(h > 0 || m > 0 ? ('00' + s).substr(-2) : s);

	if (withSuffix) {
		t.push(',' + (time % 10));
	}

	return t.join('')
};

const formatShooting = (sh) => {
	if (sh === -1) {
		return 'x'
	}
	if (sh === -2) {
		return ''
	}
	return sh
};

const getCompGroup = (info, compGroupId) => {
	if (!info || !compGroupId) {
		return null
	}
	if (info.compGroups && info.compGroups.length) {
		for (let i = 0; i < info.compGroups.length; i++) {
			if (info.compGroups[i].compGroupId === 1 * compGroupId) {
				return info.compGroups[i];
			}
		}
	}
	return null;
};

const formatRow = (row, lastResults) => {
	const key = row.compGroupId + '-' + row.racerId;
	if (row.totalTime > 0
		&& lastResults[key]
		&& lastResults[key].update > (Date.currentTS() - 10)) {
		return "flashit";
	}
	return null;
};

export default class Results extends Component {

	renderPenalties(raceResult) {
		if (!raceResult || raceResult.isFetchingItem || raceResult.item === null) {
			return null
		}
		if (!raceResult.item.resultUsers || !raceResult.item.resultUsers.length) {
			return null
		}

		let rows = [];
		if (raceResult.item.resultPenalties && raceResult.item.resultPenalties.length) {
			for (let i = 0; i < raceResult.item.resultPenalties.length; i++) {
				const p = raceResult.item.resultPenalties[i];
				let s = ['st. č. ' + p.startOrder];
				switch (p.severity) {
					case 1:
						s.push('- důtka');
						break;
					case 2:
						s.push('- zákaz startu');
						break;
					case 3:
						s.push('- přirážka ' + formatPenalty(p.charge * p.repeat, false));
						break;
					case 4:
						if (p.isDsq) {
							s.push('- diskvalifikace');
						} else {
							s.push('- návrh na diskvalifikaci');
						}
						break;
					case 5:
						s.push('- zdržení -' + formatPenalty(p.charge * -1));
						break;
					case 0:
					default:
						break;
				}
				if (p.article) {
					s.push('(' + p.article + ')');
				}
				if (p.description) {
					s.push('- ' + p.description)
				}
				rows.push(<div key={i}>{s.join(' ')}</div>)
			}
		}

		if (rows.length) {
			return <div>
				<h3>Poznámky</h3>
				{rows}
			</div>
		} else {
			return null
		}
	}

	renderResults(info, compGroupId, raceResult, ranked) {
		if (!info || !compGroupId) {
			return ranked ? <span>Zvolte prosím kategorii</span> : null
		}

		let isLoader = false;
		if (!raceResult || raceResult.isFetchingItem || raceResult.item === null) {
			if (raceResult.isFetchingItem && raceResult.item && raceResult.item.resultUsers) {
				isLoader = true;
			} else {
				return ranked ? Grid.renderIsFetchingData("Výsledky se nahrávají ...") : null;
			}
		}
		if (!raceResult.item.resultUsers || !raceResult.item.resultUsers.length) {
			return ranked ? <span>Výsledky nenalezeny</span> : null;
		}

		const cols = [
			<TableHeaderColumn key="1" dataField="rank" width='8%' dataAlign="right" dataFormat={formatRank}>{ranked ? 'Poř.' : ''}</TableHeaderColumn>,
			<TableHeaderColumn key="2" dataField="startOrder" width='8%' dataAlign="right">St. č.</TableHeaderColumn>,
			<TableHeaderColumn key="3" dataField="lastName" width='25%' dataAlign="left" dataFormat={formatFullName}>Jméno</TableHeaderColumn>,
			<TableHeaderColumn key="4" dataField="clubAbbr" width='24%' dataAlign="left">Klub</TableHeaderColumn>
		];

		const compGroup = getCompGroup(info, compGroupId);
		if (compGroup) {
			for (let i = 1; i <= 4; i++) {
				const sh = 'shooting' + i;
				if (compGroup[sh] && compGroup[sh] !== '-') {
					cols.push(<TableHeaderColumn key={sh} dataField={sh} width='5%' dataAlign="center" dataFormat={formatShooting}>{compGroup[sh].toUpperCase()}</TableHeaderColumn>)
				}
			}
		}

		cols.push(<TableHeaderColumn key="10" dataField="totalTime" width='15%' dataAlign="right" dataFormat={formatTotalTime}>{ranked ? 'Čas' : ''}</TableHeaderColumn>);

		const filter = {};
		const options = Grid.getTableOptions(filter);
		const items = raceResult.item.resultUsers.filter((item) => (ranked && item.rank > 0) || (!ranked && item.rank <= 0));
		if (!items.length) {
			return null
		}

		return <div style={isLoader ? {opacity: 0.2} : {}}>
			{ranked ? null : <h3>Na trati, DNF, DNS, DSQ</h3>}
			{Grid.renderTable(items, items.length, options, cols, false, true, 'table-results', true, (row) => formatRow(row, this.props.lastResults))}
		</div>
	}

	render() {
		const {raceInfo, compGroupId, raceResult} = this.props;

		if (!raceInfo || raceInfo.item === null) {
			return Grid.renderIsFetchingData("Závod se nahrává ...");
		}
		const info = raceInfo.item;
		const race = info.race;
		if (!race || !race.raceId) {
			return <span>Závod nenalezen</span>
		}

		return (
			<div>
				{this.renderResults(info, compGroupId, raceResult, true)}
				{this.renderResults(info, compGroupId, raceResult, false)}
				{this.renderPenalties(raceResult)}
			</div>
		);
	}
}


Results.propTypes = {
	seasons: PropTypes.object,
	raceInfo: PropTypes.object,
	compGroupId: PropTypes.string,
	raceResult: PropTypes.object,
	lastResults: PropTypes.object
};



// WEBPACK FOOTER //
// ./P:/Work/htdocs/biatlon/online/src/components/result/Results.js